import Request from '@/plugins/request';

export function getFunds(params) {
  return Request.get('funds', { params })
}

export function createFund() {
  return Request.get(`funds/create`)
}

export function storeFund(data) {
  return Request.post('funds', data)
}

export function updateFund(id, data) {
  return Request.put(`funds/${id}`, data)
}

export function editFund(id) {
  return Request.get(`funds/${id}/edit`)
}

export function destroyFund(id) {
  return Request.delete(`funds/${id}`)
}
